"use strict";
// (C) 2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadInaccessibleDashboards = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var sdk_model_1 = require("@gooddata/sdk-model");
var flatMap_1 = tslib_1.__importDefault(require("lodash/flatMap"));
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var accessibleDashboardsSelectors_1 = require("../../../store/accessibleDashboards/accessibleDashboardsSelectors");
var inaccessibleDashboards_1 = require("../../../store/inaccessibleDashboards");
function loadInaccessibleDashboards(ctx, widgets) {
    var accessibleDashboardsMap, dashboardDrillTargets, dashboardDrillTargetRefs, unknownDashboardDrillTargetRefs, existingDashboards, inaccessibleDashboards;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(accessibleDashboardsSelectors_1.selectAccessibleDashboardsMap)];
            case 1:
                accessibleDashboardsMap = _a.sent();
                dashboardDrillTargets = flatMap_1.default(widgets.filter(sdk_model_1.isInsightWidget).map(function (_a) {
                    var drills = _a.drills;
                    return drills.filter(sdk_model_1.isDrillToDashboard);
                }));
                dashboardDrillTargetRefs = compact_1.default(dashboardDrillTargets.map(function (_a) {
                    var target = _a.target;
                    return target;
                }));
                unknownDashboardDrillTargetRefs = dashboardDrillTargetRefs.filter(function (ref) { return !accessibleDashboardsMap.get(ref); });
                return [4 /*yield*/, effects_1.call(getExistingDashboards, ctx, unknownDashboardDrillTargetRefs)];
            case 2:
                existingDashboards = _a.sent();
                inaccessibleDashboards = existingDashboards.map(function (dashboard) {
                    var _a;
                    return tslib_1.__assign(tslib_1.__assign({}, dashboard), { title: (_a = dashboard.title) !== null && _a !== void 0 ? _a : "", accessibilityLimitation: dashboard.title === undefined ? "forbidden" : "notShared" });
                });
                return [4 /*yield*/, effects_1.put(inaccessibleDashboards_1.inaccessibleDashboardsActions.addInaccessibleDashboards(inaccessibleDashboards))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.loadInaccessibleDashboards = loadInaccessibleDashboards;
function getExistingDashboards(ctx, dashboardRefs) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ctx.backend
                            .workspace(ctx.workspace)
                            .dashboards()
                            .validateDashboardsExistence(dashboardRefs)];
                case 1: return [2 /*return*/, _b.sent()];
                case 2:
                    _a = _b.sent();
                    // when the call fails, we have no way to check whether the unknown dashboards exist
                    return [2 /*return*/, []];
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=loadInaccessibleDashboards.js.map